<template>
  <div  :style="{'color': color}">
    <div  v-if="mode === 'DESIGN'" class="description">
      <el-icon class="el-icon-warning-outline"></el-icon>{{ placeholder }}
    </div>
    <template v-else>
      <div v-if="!readerMode" class="description description-input">
        <el-icon class="el-icon-warning-outline"></el-icon>{{placeholder}}
      </div>
      <template v-else>
        <div v-if="!showDetail" class="description description-show"><el-icon class="el-icon-warning-outline"></el-icon>{{placeholder}}</div>
      </template>
    </template>
  </div>

</template>

<script>
import componentMinxins from '../ComponentMinxins'

export default {
  mixins: [componentMinxins],
  name: "Description",
  components: {},
  props: {
    color:{
      type: String,
      default: '#939696'
    },
    placeholder: {
      type: String,
      default: '请输入说明文字'
    },
    readerMode: {
      type: Boolean,
      default: false
    },
    showDetail: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {}
  },
  methods: {}
}
</script>

<style scoped>
  .description{
    font-size: 14px;
    margin-bottom: 14px;
    line-height: 1.5;
    text-align: left;
    clear: both;
    color: #f00;
  }
  .description-input{
    margin-top: -8px;
  }
  .description-show{
    margin-top: 0px;
  }
</style>
